import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';
import {
  INotification,
  INotificationPreferences,
  ICaseNotificationPreferences,
  ITaskNotificationPreferences,
  ICalendarEventNotificationPreferences,
} from '@/models';

import { http } from './http';
import { IGetParams } from './types';

// Define the actual notification API response structure
interface INotificationApiResponse {
  data: INotification[];
  grouped: {
    today: INotification[];
    previous: INotification[];
  };
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const NotificationApi = {
  getNotifications: async (
    params?: IGetParams,
  ): Promise<AxiosResponse<INotificationApiResponse>> => {
    return http.get(`api/${ApiVersion.V1}/notifications`, { params });
  },

  getUnreadCount: async (): Promise<AxiosResponse<{ count: number }>> => {
    return http.get(`api/${ApiVersion.V1}/notifications/unread-count`);
  },

  dismissNotification: async (
    notificationId: string,
  ): Promise<AxiosResponse<INotification>> => {
    return http.patch(
      `api/${ApiVersion.V1}/notifications/${notificationId}/dismiss`,
    );
  },

  dismissAllNotifications: async (): Promise<AxiosResponse<void>> => {
    return http.patch(`api/${ApiVersion.V1}/notifications/dismiss-all`);
  },

  getNotificationPreferences: async (): Promise<
    AxiosResponse<INotificationPreferences>
  > => {
    return http.get(`api/${ApiVersion.V1}/notifications/preferences`);
  },

  updateNotificationPreferences: async (preferences: {
    caseNotifications?: ICaseNotificationPreferences;
    taskNotifications?: ITaskNotificationPreferences;
    calendarEventNotifications?: ICalendarEventNotificationPreferences;
  }): Promise<AxiosResponse<INotificationPreferences>> => {
    return http.patch(
      `api/${ApiVersion.V1}/notifications/preferences`,
      preferences,
    );
  },

  markAsRead: async (
    notificationId: string,
  ): Promise<AxiosResponse<INotification>> => {
    return http.patch(
      `api/${ApiVersion.V1}/notifications/${notificationId}/read`,
    );
  },

  markAllAsRead: async (): Promise<AxiosResponse<void>> => {
    return http.patch(`api/${ApiVersion.V1}/notifications/mark-all-read`);
  },
};
